import React from 'react';
import './home.css';
import SEOHead from './components/SEOHead';
import { buildOrganizationJsonLd, buildWebSiteJsonLd, SITE_URL } from './utils/seo';
import MainHeader from './header/MainHeader';
import HeroSection from './components/HeroSection';
import SearchModule from './components/SearchModule';
import CategorySection from './components/CategorySection';
import FeaturedSection from './components/FeaturedSection';
import TrustIndicators from './components/TrustIndicators';
import CTASection from './components/CTASection';
import Footer from './footer/Footer';
import HowItWorks from './components/HowItWorks';
import PopularBrands from './components/PopularBrands';
import Testimonials from './components/Testimonials';

export default function Home() {
  return (
    <div className="home-page-light">
      <SEOHead
        title="Blej & Shit Makina Online në Shqipëri | Vetura të Sigurta"
        description="Platforma më e madhe për shitjen e makinave në Shqipëri. Gjej makina të sigurta, me dokumenta të plota dhe çmime konkurruese. Blej makinën tënde të ëndrës sot!"
        canonical={SITE_URL}
        jsonLd={[buildOrganizationJsonLd(), buildWebSiteJsonLd()]}
      />
      <MainHeader />
      
      <main>
        <HeroSection />
        <SearchModule />
        <FeaturedSection />
        <CategorySection />
        <PopularBrands />
        <HowItWorks />
        <Testimonials />
        <TrustIndicators />
        <CTASection />
      </main>

      <Footer />
    </div>
  );
}
